<template lang="html">
<div>
    <div class="foot-player">
          <div @click="goInner" :class="['imgs',classState]">
                <img :src="songDat[0].songImg || this.songImg" alt="">
          </div>
          <div @click="goInner" class="song-content">{{songDat[0].songName || '无播放曲目'}}</div>
          <div class="play-icon" @click="playSet">
                <van-icon v-if="state=='playing'" class="icon" class-prefix="iconfont" name="pause2" />
                <van-icon v-else class="icon" class-prefix="iconfont" name="play2" />
          </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import imgUrl from '@/assets/play.png';
export default {
    computed:{
        ...mapState('player',{
             state:'state',
             audio:'audio',
             songDat:'songDat',
             classState(state){
                 return state.state == 'playing' ? 'act' : 'pause';
             }
        })
    },
    data(){
        return{
             songImg:imgUrl
        }
    },
    methods:{
        playSet:function(){
             if(this.state == 'playing'){
                  this.audio[0].pause();
             }else{
                  this.audio[0].play();
             }
        },
        goInner:function(){
             if(this.songDat[0].icd){
                 this.push({
                      path:'song',
                      query:{
                          icd:this.songDat[0].icd,
                          iab:this.songDat[0].iab,
                          unSet:true
                      }
                 })
             }
        }
    }
}
</script>

<style lang="css" scoped>

.foot-player{
    height: 60px;
    width: 100%;
    position: fixed;
    background: white;
    left: 0px;
    bottom: 0px;
    display: flex;
    align-items: center;
    z-index: 9;
    box-shadow: 0px -3px 3px #999999;
}

.imgs{
    width: 65px;
    height: 65px;
    border-radius: 65px;
    background: #f5f5f5;
    margin-left: 12px;
    margin-top: -18px;
    overflow: hidden;
}

.imgs img{
    width: 65px;
    height: 65px;
    border-radius: 65px;
    position: relative;

    animation-name: playing;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-duration: 5s;
}

.imgs.act img{
    animation-play-state: running;
}

@keyframes playing {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}

.imgs.pause img{
    animation-play-state: paused;
}

.song-content{
    flex-grow: 1;
    margin-left: 15px;
    font-size: 15px;
}

.play-icon{
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.play-icon .icon{
    font-size: 24px;
    color: #666666;
}

</style>
